import {
  Box,
  Grid2,
  IconButton,
  MenuItem,
  TableCell,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { pdf } from "@react-pdf/renderer";
import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import Breadcrumbs from "../../../component/Breadcrumbs";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import SnackBar from "../../../component/SnackBar";
import {
  CreateJustification,
  CreateSubmissionDocument,
  SubmissionDocument,
  UpdateSubmissionDocument,
  VerifiedDocument,
} from "../../../redux/action/Submission";
import { buildUrl, HandleSkeletion } from "../../../utils/constants";
import CommonTable from "../../candidates/Table";
import { CustomDiv } from "../../chat-bot/style";
import CommonAccordion from "../../common-components/CommonAccordion";
import {
  CommonGrid2,
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import Justification from "./components/Justification";
import JustificationPDF from "./components/JustificationPDF";
import SubmissionMixedComponent from "./components/MixedComponenet";
import PreScreenQuestion from "./components/PreScreen";
import PreScreenPDF from "./components/PreScreenPDF";
import DropDownSelect from "../../../component/Select";
import DeleteIco from "../../../assets/icons/DeleteIco";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import { ErrorContent } from "../style";

export default function Submission() {
  const [isLoading, setIsLoading] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const submissionId = query.get("match-id");
  const jobId = query.get("id");
  const getBreadcrumb = query.get("breadcrumbs");
  const submissionDocument = query.get("document");
  const dispatch = useDispatch();
  const submission = useSelector((state) => state.submission.submission);
  const [expandedPanel, setExpandedPanel] = useState(["Editable Information"]);
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const lg = useMediaQuery("(min-width:767px)");
  const debounceTimer = useRef();
  const submissionDocumentValue = {
    bill_rate_to_client: "",
    discounts_applied: "",
    linkedin_profile: "",
    pay_rate_to_client: "",
    portfolio: "",
    ssn_digits: "",
    bill_currency_to_client: "",
    pay_currency_to_client: "",
    discounts_applied_data: [{ name: "Yes" }, { name: "No" }],
    id: "",

    client: "",
    job_id: "",
    position_title: "",
    project_locations: "",
    project_duration: "",
    target_bill_rate: "",
    first_name: "",
    last_name: "",
    email: "",
    dob: "",
    notice_period: "",
    willing_to_relocate: "",
    willing_to_relocate_data: [{ name: "Yes" }, { name: "No" }],
    willing_to_be_onsite: "",
    willing_to_be_onsite_data: [{ name: "Yes" }, { name: "No" }],
    work_authorization: "",
    work_authorization_valid_till: "",
    porche: null,
    porche_data: [{ name: "Yes" }, { name: "No" }],
    manager_name: "",
    department: "",
    employment_period: {
      start_date: "",
      end_date: "",
    },
    employment_type: "",

    employment_data: [{ name: "Permanent" }, { name: "Contract" }],
    tax_term: "",
    tax_term_data: [
      { name: "C2C" },
      { name: "1099" },
      { name: "W2 Contract" },
      { name: "W2 Employee" },
    ],
    extension_phone: "",
    emplopyer_name: "",
    emplopyer_phone: "",
    emplopyer_email: "",
    emplopyer_contact_name: "",
    hour_rate: "",
    contract_hour_rate: "",
    employee_hour_rate: "",

    skills_summary: [],
    supporting_evidence: [],
    risks_and_remediation: [],
    pre_screen_question_answers: [],
    candidate_fit_summary: "",
    location_value: "",
    is_updated: false,
  };
  const [submissionValue, setSubmissionValue] = useState(
    submissionDocumentValue
  );
  const [chatBotData, setChatBotData] = React.useState({
    value: "",
    loader: false,
  });
  const [buttonLoading, setButtonLoading] = useState({
    submitLoading: false,
    disabled: false,
    verifiedLoading: false,
  });
  const [tableData, setTableData] = useState({
    skills_summary: [],
    supporting_evidence: [],
    risks_and_remediation: [],
  });
  const [riskAnalysisDialog, setRiskAnalysisDialog] = useState({
    open: false,
    data: {},
  });

  const skillSummaryHeader = [
    { name: "Core Skills" },
    { name: "Rating out 5" },
    { name: "Relevancy" },
    { name: "Experience In Years" },
    { name: "Comment", minWidth: "400px" },
  ];

  const supportingEvidenceHeader = [
    { name: "Task" },
    // { name: "Status", minWidth: "50px" },
  ];

  const riskAnalysis = [
    { name: "Potential Risk" },
    { name: "Remediation" },
    { name: "Risk level", width: "100px" },
    { width: "50px" },
  ];

  useEffect(() => {
    if (Object.keys(submission).length !== 0) {
      setSubmissionValue({
        ...submissionValue,
        bill_rate_to_client:
          submission.accessible_information?.bill_rate_to_client,
        discounts_applied: submission.accessible_information?.discounts_applied,
        linkedin_profile: submission.accessible_information?.linkedin_profile,
        pay_rate_to_client:
          submission.accessible_information?.pay_rate_to_client,
        portfolio: submission.accessible_information?.portfolio,
        ssn_digits: submission.accessible_information?.ssn_digits,
        id: submission.id,

        bill_currency_to_client:
          submission.accessible_information?.bill_currency_to_client,
        pay_currency_to_client:
          submission.accessible_information?.pay_currency_to_client,

        client: submission.job_summary?.client,
        job_id: submission.job_summary?.req_id,
        position_title: submission.job_summary?.position_title,
        project_locations: submission.job_summary?.project_locations?.map(
          (item) => {
            return { content: item, id: "" };
          }
        ),
        project_duration: submission.job_summary?.project_duration,
        target_bill_rate: submission.job_summary?.target_bill_rate,
        first_name: submission.candidate_information?.first_name,
        last_name: submission.candidate_information?.last_name,
        email: submission.candidate_information?.email,
        dob: submission.candidate_information?.dob,
        notice_period: submission.candidate_information?.notice_period,
        willing_to_relocate: submission.candidate_information
          ?.willing_to_relocate
          ? "Yes"
          : "No",
        willing_to_be_onsite: submission.candidate_information
          ?.willing_to_be_onsite
          ? "Yes"
          : "No",
        work_authorization:
          submission.candidate_information?.work_authorization,
        work_authorization_valid_till:
          submission.candidate_information?.work_authorization_valid_till,
        porche: submission.prior_working_with_client?.porche,
        manager_name: submission.prior_working_with_client?.manager_name,
        department: submission.prior_working_with_client?.department,
        employment_type: submission.prior_working_with_client?.employment_type,
        employment_period: {
          start_date:
            submission.prior_working_with_client?.employment_period
              ?.start_date || "",
          end_date:
            submission.prior_working_with_client?.employment_period?.end_date ||
            "",
        },

        tax_term: submission.engagement?.tax_term,
        emplopyer_name: submission.engagement?.emplopyer_name,
        emplopyer_phone: submission.engagement?.emplopyer_phone,
        emplopyer_email: submission.engagement?.emplopyer_email,
        extension_phone: submission.engagement?.extension_phone,
        emplopyer_contact_name: submission.engagement?.emplopyer_contact_name,
        hour_rate: submission.engagement?.hour_rate,
        contract_hour_rate: submission.engagement?.contract_hour_rate,
        employee_hour_rate: submission.engagement?.employee_hour_rate,

        skills_summary: submission.justification?.skills_summary,
        supporting_evidence: submission.justification?.supporting_evidence,
        risks_and_remediation: submission.justification?.risks_and_remediation,

        pre_screen_question_answers: submission.pre_screen_question_answers,
        candidate_fit_summary: submission.justification?.candidate_fit_summary,
        is_updated: submission?.is_updated,
      });
      setTableData({
        skills_summary: submission.justification?.skills_summary,
        supporting_evidence: submission.justification?.supporting_evidence,
        risks_and_remediation: submission.justification?.risks_and_remediation,
      });
    }
  }, [submission]);

  const fetchSubmissionDocument = async () => {
    try {
      setIsLoading(true);
      // if (submissionDocument === "false") {
      //   await CreateSubmissionDocument(submissionId);
      // }
      const data = await dispatch(SubmissionDocument(submissionId));
      setIsLoading(false);
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setIsLoading(true);
    }
  };

  useEffect(() => {
    fetchSubmissionDocument();
  }, []);

  const additionalParams = {
    title: query.get("title") || "",
    value: query.get("value") || "",
    id: jobId || "",
  };

  const breadCrumbData = [
    ...(getBreadcrumb &&
    getBreadcrumb !== "null" &&
    getBreadcrumb !== "undefined"
      ? [
          {
            title: "Work Flow",
            navigate: `/job-krystal-path`,
          },
        ]
      : [
          {
            title: "Jobs",
            navigate: `/jobs`,
          },
        ]),
    {
      title: query.get("title"),
      navigate: buildUrl("/jobs/jobs-view", additionalParams, getBreadcrumb),
    },
    {
      title: "Submission Document",
      active: true,
    },
  ];

  const editableInformation = [
    {
      title: "Bill Rate to Client",
      fontSize: "15px",
      placeholderFontSize: "15px",
      placeholder: "Enter your Rate",
      component: "input-select",
      titleName: "bill_rate_to_client",
      currency: "bill_currency_to_client",
      size: 6,
      menuItemData: [{ name: "USD" }, { name: "INR" }],
    },
    {
      title: "Pay Rate to Client",
      fontSize: "15px",
      placeholderFontSize: "15px",
      placeholder: "Enter your Rate",
      component: "input-select",
      titleName: "pay_rate_to_client",
      currency: "pay_currency_to_client",
      size: 6,
      menuItemData: [{ name: "USD" }, { name: "INR" }],
    },
    {
      title: "Last 4 digits of SSN",
      component: "input",
      fontSize: "15px",
      titleName: "ssn_digits",
      placeholderFontSize: "15px",
      placeholder: "Enter your SSN",
      maxLength: 4,
    },
    {
      title: "LinkedIn Profile",
      component: "input",
      fontSize: "15px",
      titleName: "linkedin_profile",
      placeholderFontSize: "15px",
      placeholder: "Enter your LinkedIn Profile",
    },
    {
      title: "Portfolio",
      component: "input",
      fontSize: "15px",
      titleName: "portfolio",
      placeholderFontSize: "15px",
      placeholder: "Enter your Portfolio",
    },
    {
      title: "Discounts Applied",
      component: "dropDown",
      titleName: "discounts_applied",
      dropDownData: "discounts_applied_data",
      placeholder: "Select the Discount Applied",
    },
  ];

  const jobSummary = [
    {
      title: "Client",
      component: "input",
      fontSize: "15px",
      titleName: "client",
      placeholderFontSize: "15px",
      placeholder: "Enter the Client Name",
      disabled: true,
    },
    {
      title: "Job/Request ID",
      component: "input",
      fontSize: "15px",
      titleName: "job_id",
      placeholderFontSize: "15px",
      placeholder: "Enter the Job/Request ID",
      disabled: true,
    },
    {
      title: "Position Title",
      component: "input",
      fontSize: "15px",
      titleName: "position_title",
      placeholderFontSize: "15px",
      placeholder: "Enter your Position Title",
      disabled: true,
    },
    {
      title: "Project Locations",
      component: "autoComplete",
      fontSize: "15px",
      titleName: "project_locations",
      placeholderFontSize: "15px",
      placeholder: "Enter your Project Locations",
      disabled: true,
      inputValue: "location_value",
    },
    {
      title: "Project Duration",
      component: "input",
      fontSize: "15px",
      titleName: "project_duration",
      placeholderFontSize: "15px",
      placeholder: "Enter the Duration",
      disabled: true,
    },
    {
      title: "Target Bill Rate",
      fontSize: "15px",
      placeholderFontSize: "15px",
      placeholder: "Enter your Rate",
      component: "input",
      titleName: "target_bill_rate",

      disabled: true,
    },
  ];

  const candidateInformation = [
    {
      title: "First Name",
      component: "input",
      fontSize: "15px",
      titleName: "first_name",
      placeholderFontSize: "15px",
      placeholder: "Enter the First Name",
      disabled: true,
    },
    {
      title: "Last Name",
      component: "input",
      fontSize: "15px",
      titleName: "last_name",
      placeholderFontSize: "15px",
      placeholder: "Enter the Last Name",
      disabled: true,
    },
    {
      title: "Email",
      component: "input",
      fontSize: "15px",
      titleName: "email",
      placeholderFontSize: "15px",
      placeholder: "Enter the email",
      disabled: true,
    },
    {
      title: " Day and Month of Birth",
      name: "Oct 30",
      component: "dob_month",
      titleName: "dob",
      disabled: true,
    },
    {
      title: "Notice Period",
      component: "input",
      fontSize: "15px",
      titleName: "notice_period",
      placeholderFontSize: "15px",
      placeholder: "Enter your Notice Period",
      disabled: true,
    },
    {
      title: "Willing to Relocate",
      placeholder: "Are you Willing to Relocate",
      component: "dropDown",
      titleName: "willing_to_relocate",
      dropDownData: "willing_to_relocate_data",
      disabled: true,
    },
    {
      title: "Willing to work Onsite/Hybrid",
      placeholder: "Are you Willing to work Onsite/Hybrid",
      component: "dropDown",
      titleName: "willing_to_be_onsite",
      dropDownData: "willing_to_be_onsite_data",
      disabled: true,
    },
    {
      title: "Worth Authorization",
      component: "input",
      fontSize: "15px",
      titleName: "work_authorization",
      placeholderFontSize: "15px",
      placeholder: "Enter your Worth Authorization",
      disabled: true,
    },
    {
      title: "Work Authorization Valid till",
      titleName: "work_authorization_valid_till",
      component: "single-calender",
      placeholder: "Select date",
      disabled: true,
    },
  ];

  const previousExperience = [
    {
      title: `Have you worked in the past with ${submission?.job_summary?.client}?`,
      component: "dropDown",
      titleName: "porche",
      dropDownData: "porche_data",
      size: 8,
      disabled: true,
    },
  ];

  const conditionalExperience = [
    {
      title: "Employment Period",
      titleName: "employment_period",
      component: "calender",
      placeholder: "Select period",
      disabled: true,
    },
    {
      title: "Department",
      component: "input",
      fontSize: "15px",
      titleName: "department",
      placeholderFontSize: "15px",
      placeholder: "Enter department",
      disabled: true,
    },

    {
      title: "Type of Employment",
      component: "dropDown",
      titleName: "employment_type",
      dropDownData: "employment_data",
      placeholder: "Select Answer",
      disabled: true,
    },
    {
      title: "Manager Name",
      component: "input",
      fontSize: "15px",
      titleName: "manager_name",
      placeholderFontSize: "15px",
      placeholder: "Enter manager name",
      disabled: true,
    },
  ];

  const engagement = [
    {
      title: "Tax Term",
      component: "dropDown",
      titleName: "tax_term",
      dropDownData: "tax_term_data",
      placeholder: "Select tax term",
      disabled: true,
    },
  ];

  const conditional_C2C = [
    {
      title: "Employer Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Employer Name",
      disabled: true,
    },
    {
      title: "Hourly Bill Rate",
      component: "hour",
      fontSize: "15px",
      titleName: "hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: true,
    },
    {
      component: "split-screen",
      data: [
        {
          size: 8,
          title: "Employer Phone",
          component: "phone-number",
          fontSize: "15px",
          titleName: "emplopyer_phone",
          placeholderFontSize: "15px",
          country: "emplopyer_phone_country",
          placeholder: "Enter Employer Phone",
          disabled: true,
        },
        {
          size: 4,
          title: "Extension(Opt).",
          component: "input",
          fontSize: "15px",
          titleName: "extension_phone",
          placeholderFontSize: "15px",
          placeholder: "Enter extension",
          disabled: true,
        },
      ],
    },
    {
      title: "Employer Email",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_email",
      placeholderFontSize: "15px",
      placeholder: "Enter Email",
      disabled: true,
    },
    {
      title: "Employer Contact Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_contact_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Contact Name",
      disabled: true,
    },
  ];

  const conditional_w2contract = [
    {
      title: "All Inclusive Hourly Pay Rate",
      component: "hour",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "contract_hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: true,
    },
  ];

  const conditional_w2employee = [
    {
      title: "All Inclusive Hourly Pay Rate or Annual Salary",
      component: "hour",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "employee_hour_rate",
      placeholder: "Enter Hourly rate or Annual Salary",
      disabled: true,
    },
  ];

  const handleDownloadPDF = async (values) => {
    // const blob = await pdf(<SubmissionPDF />).toBlob();
    // const blob = await pdf(<JustificationPDF values={values} />).toBlob();
    // const blob = await pdf(<PreScreenPDF values={values} />).toBlob();
    // const url = URL.createObjectURL(blob);

    // const link = document.createElement("a");
    // link.href = url;
    // link.download = "submission.pdf";
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    const downloadBlob = (blob, filename) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    };

    try {
      // const submissionBlob = await pdf(
      //   <SubmissionPDF values={values} />
      // ).toBlob();
      // downloadBlob(submissionBlob, "submission.pdf");

      const justificationBlob = await pdf(
        <JustificationPDF values={values} />
      ).toBlob();
      downloadBlob(justificationBlob, "justification.pdf");

      // const preScreenBlob = await pdf(
      //   <PreScreenPDF values={values} />
      // ).toBlob();
      // downloadBlob(preScreenBlob, "prescreen.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  const handleVerified = async (values) => {
    setButtonLoading((prev) => ({
      ...prev,
      disabled: true,
      verifiedLoading: true,
    }));
    const justificationBlob = await pdf(
      <JustificationPDF values={values} />
    ).toBlob();
    let preScreenBlob = null;
    if (
      values.pre_screen_question_answers &&
      values.pre_screen_question_answers.length !== 0
    ) {
      preScreenBlob = await pdf(
        <PreScreenPDF values={values} lg={lg} />
      ).toBlob();
    }
    try {
      const formData = new FormData();
      formData.append("files", justificationBlob, "Justification.pdf");
      if (preScreenBlob) {
        formData.append("files", preScreenBlob, "PreScreen.pdf");
      }
      const data = await VerifiedDocument(submissionValue.id, formData);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      setButtonLoading((prev) => ({
        ...prev,
        disabled: true,
        verifiedLoading: false,
      }));
    } catch (error) {
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        verifiedLoading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleChangeAccor = (panel) => (_, isExpanded) => {
    setExpandedPanel((prev) =>
      isExpanded ? [...prev, panel] : prev.filter((p) => p !== panel)
    );
  };

  const handleTableChange = (e, index, setFieldValue, name, condition) => {
    const updated = tableData[name].map((item, itemIndex) =>
      itemIndex === index ? { ...item, [condition]: e.target.value } : item
    );
    setTableData((prev) => ({
      ...prev,
      [name]: updated,
    }));

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(name, updated);
    }, 500);
  };

  const handleTableSingleChange = (
    e,
    index,
    setFieldValue,
    name,
    condition
  ) => {
    const updated = tableData[name].map((item, itemIndex) =>
      itemIndex === index ? e.target.value : item
    );
    setTableData((prev) => ({
      ...prev,
      [name]: updated,
    }));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(name, updated);
    }, 500);
  };

  const handleSkillSummaryTableBodyData = (row, index, setFieldValue, name) => {
    return (
      <>
        <TableCell>{row.skill}</TableCell>
        <TableCell>{row.rating || "-"}</TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.relevancy === "High"
                  ? "green"
                  : row.relevancy === "Medium"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.relevancy}
          </StatusChange>
        </TableCell>
        <TableCell>{row.experience_in_yrs || "-"}</TableCell>
        <TableCell>
          <CommonTextField
            value={row.comment}
            rows={2}
            fullWidth
            onChange={(e) =>
              handleTableChange(e, index, setFieldValue, name, "comment")
            }
            multiline
            padding={"0px"}
            customStyle={{
              "& .MuiInputBase-root": {
                padding: "10px",
              },
              "& textArea": {
                fontSize: "14px !important",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "5px",
                },
              },
            }}
          />
        </TableCell>
      </>
    );
  };

  const handleSummaryEvidenceTableBodyData = (
    row,
    index,
    setFieldValue,
    name
  ) => {
    return (
      <>
        <TableCell>
          <CommonTextField
            value={row}
            rows={2}
            multiline
            onChange={(e) =>
              handleTableSingleChange(e, index, setFieldValue, name)
            }
            fullWidth
            padding={"0px"}
            customStyle={{
              "& .MuiInputBase-root": {
                padding: "10px",
              },
              "& textArea": {
                fontSize: "14px !important",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "5px",
                },
              },
            }}
          />
        </TableCell>
        {/* <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.relevancy === "High"
                  ? "green"
                  : row.relevancy === "Medium"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.relevancy}
          </StatusChange>
        </TableCell> */}
      </>
    );
  };

  const statusOptions = [
    { label: "High", color: "#17B26A" },
    { label: "Medium", color: "orange" },
    { label: "Low", color: "#667085" },
  ];

  const CustomMenuItem = (item, index) => (
    <MenuItem key={index} value={item.label}>
      {item.label}
    </MenuItem>
  );

  const handleDeleteClick = (row, index, setFieldValue, name) => {
    setRiskAnalysisDialog((prev) => ({
      ...prev,
      open: true,
      data: {
        row: row,
        index: index,
        setFieldValue: setFieldValue,
        name: name,
      },
    }));
  };

  const handleRiskAnalysisDialogDialogClose = () => {
    setRiskAnalysisDialog((prev) => ({
      ...prev,
      open: false,
      loading: false,
      data: {},
    }));
  };

  const handleDeleteRiskAnalysis = () => {
    setRiskAnalysisDialog((prev) => ({
      ...prev,
      loading: true,
    }));
    const updated = tableData[riskAnalysisDialog.data.name].filter(
      (item, itemIndex) => itemIndex !== riskAnalysisDialog.data.index
    );

    setTableData((prev) => ({
      ...prev,
      [riskAnalysisDialog.data.name]: updated,
    }));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(() => {
      riskAnalysisDialog.data.setFieldValue(
        riskAnalysisDialog.data.name,
        updated
      );
      handleRiskAnalysisDialogDialogClose();
    }, 500);
  };

  const handleAddRiskAnalysis = (setFieldValue, name, values) => {
    setExpandedPanel([...expandedPanel, "Risk Analysis"]);
    let data = {
      risk: "",
      risk_level: "",
      remediation: "",
    };
    setTableData((prev) => ({
      ...prev,
      [name]: [...prev.risks_and_remediation, data],
    }));
    setFieldValue(name, [...values[name], data]);
  };

  const handleRiskAnalysisTableBodyData = (
    row,
    index,
    setFieldValue,
    name,
    error
  ) => {
    return (
      <>
        <TableCell>
          <CommonTextField
            value={row.risk}
            rows={2}
            multiline
            onChange={(e) =>
              handleTableChange(e, index, setFieldValue, name, "risk")
            }
            fullWidth
            padding={"0px"}
            customStyle={{
              "& .MuiInputBase-root": {
                padding: "10px",
              },
              "& textArea": {
                fontSize: "14px !important",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "5px",
                },
              },
            }}
          />
          {error?.[index]?.risk && (
            <ErrorContent>{error?.[index]?.risk}</ErrorContent>
          )}
        </TableCell>
        <TableCell>
          <CommonTextField
            value={row.remediation}
            rows={2}
            multiline
            onChange={(e) =>
              handleTableChange(e, index, setFieldValue, name, "remediation")
            }
            padding={"0px"}
            customStyle={{
              "& .MuiInputBase-root": {
                padding: "10px",
              },
              "& textArea": {
                fontSize: "14px !important",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "5px",
                },
              },
            }}
          />
          {error?.[index]?.remediation && (
            <ErrorContent>{error?.[index]?.remediation}</ErrorContent>
          )}
        </TableCell>
        <TableCell>
          <DropDownSelect
            marginTop="0px"
            removeAnimation={true}
            renderValue={false}
            data={statusOptions}
            valueChange={true}
            CustomMenuItem={CustomMenuItem}
            handleRenderValue={(selected) => {
              const selectedOption = statusOptions.find(
                (option) => option.label === selected
              );

              console.log(selected, selectedOption, "sflksfnlksfnskfkfk");
              return (
                <Box display={"flex"} alignItems={"center"}>
                  <DotColor color={selectedOption.color} marginRight="8px" />
                  <Typography>{selectedOption.label}</Typography>
                </Box>
              );
            }}
            customStyle={{
              width: "110px",
              "& .MuiSelect-select": {
                padding: "4px 32px 4px 10px !important",
                borderRadius: "6px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#D0D5DD",
                boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              },
              "& .MuiSelect-icon": {
                right: "0rem",
              },
              margin: "0px 10px",
            }}
            value={row.risk_level}
            handleChange={(e) =>
              handleTableChange(e, index, setFieldValue, name, "risk_level")
            }
          />
          {error?.[index]?.risk_level && (
            <ErrorContent className="Mui-error">
              {error?.[index]?.risk_level}
            </ErrorContent>
          )}
        </TableCell>
        <TableCell>
          <IconButton
            onClick={() => handleDeleteClick(row, index, setFieldValue, name)}
          >
            <DeleteIco strokeWidth={2} />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const validationSchema = Yup.object().shape({
    bill_rate_to_client: Yup.number()
      .typeError("Bill rate must be a number")
      .min(0, "Bill rate cannot be negative")
      .nullable(),
    pay_rate_to_client: Yup.number()
      .typeError("Pay rate must be a number")
      .min(0, "pay rate cannot be negative")
      .nullable(),
    ssn_digits: Yup.string().matches(
      /^\d+$/,
      "Extension must contain only numbers"
    ),
    risks_and_remediation: Yup.array().of(
      Yup.object().shape({
        risk: Yup.string().required("Risk is required"),
        risk_level: Yup.string().required("Risk level is required"),
        remediation: Yup.string().required("Remediation is required"),
      })
    ),
  });

  const handleSendMessage = async (setFieldValue) => {
    if (!chatBotData.value.trim()) return;
    let params = {
      user_input: chatBotData.value,
    };

    setChatBotData((prev) => ({
      ...prev,
      loader: true,
      value: "",
    }));
    setButtonLoading((prev) => ({
      ...prev,
      disabled: true,
    }));

    try {
      const data = await CreateJustification(submissionValue.id, params);

      setFieldValue(
        "candidate_fit_summary",
        data?.data?.rewrited_candidate_fit_summary
      );
      setChatBotData((prev) => ({
        ...prev,
        value: "",
        loader: false,
      }));
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        submitLoading: false,
      }));
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        loader: false,
        value: "",
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        submitLoading: false,
      }));
    }
  };

  const handleIconClick = (setFieldValue) => {
    handleSendMessage(setFieldValue);
  };

  const handleChatBotChange = (event, setFieldValue) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage(setFieldValue);
    }
  };

  const handleSubmission = async (values) => {
    const payload = {
      ...submission,
      accessible_information: {
        bill_rate_to_client: values.bill_rate_to_client,
        discounts_applied: values.discounts_applied,
        linkedin_profile: values.linkedin_profile,
        pay_rate_to_client: values.pay_rate_to_client,
        portfolio: values.portfolio,
        ssn_digits: values.ssn_digits,
      },
      justification: {
        ...submission.justification,
        skills_summary: values.skills_summary,
        risks_and_remediation: values.risks_and_remediation,
        supporting_evidence: values.supporting_evidence,
      },
    };
    setButtonLoading((prev) => ({
      ...prev,
      disabled: true,
      submitLoading: true,
    }));
    try {
      let data = await UpdateSubmissionDocument(submissionValue.id, payload);
      setIsLoading(true);
      await dispatch(SubmissionDocument(submissionId));
      setIsLoading(false);

      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        submitLoading: false,
      }));
    } catch (error) {
      setIsLoading(false);
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setButtonLoading((prev) => ({
        ...prev,
        disabled: false,
        submitLoading: false,
      }));
    }
  };

  const handleScrollToError = (data) => {
    setExpandedPanel((prev) => {
      const newPanels = new Set(prev);
      if (data.bill_rate_to_client || data.pay_rate_to_client) {
        newPanels.add("Editable Information");
      }
      return Array.from(newPanels);
    });

    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 300);
  };

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Breadcrumbs breadCrumbData={breadCrumbData} />
      <Formik
        enableReinitialize
        initialValues={submissionValue}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmission(values);
        }}
      >
        {({ values, errors, validateForm, setFieldValue, form }) => {
          const previous_experience_with_client = [...previousExperience];
          const previous_tax_term = [...engagement];
          const previous_conditional_w2contract = [...conditional_w2contract];
          const previous_conditional_w2employee = [...conditional_w2employee];

          if (values.porche === "Yes") {
            previous_experience_with_client.push(...conditionalExperience);
          }
          if (values.tax_term === "C2C" || values.tax_term === "1099") {
            previous_tax_term.push(...conditional_C2C);
          }
          if (values.tax_term === "W2 Contract") {
            previous_tax_term.push(...previous_conditional_w2contract);
          }
          if (values.tax_term === "W2 Employee") {
            previous_tax_term.push(...previous_conditional_w2employee);
          }

          return (
            <Form
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") e.preventDefault();
            // }}
            >
              <Grid2 container spacing={2} marginTop={"1rem"}>
                <CommonGrid2
                  size={{ xs: 12, md: 5, sm: 6 }}
                  item
                  alignItems={"center"}
                  display={"flex"}
                >
                  {isLoading ? (
                    <HandleSkeletion height={50} width={"60%"} />
                  ) : (
                    <Typography variant="h3" fontSize={"20px"}>
                      {"Submission Document"}
                    </Typography>
                  )}
                </CommonGrid2>
                <CommonGrid2
                  item
                  size={{ xs: 12, md: 7, sm: 6 }}
                  gap="1rem"
                  display="flex"
                  justifyContent={"end"}
                  height={"fit-content"}
                >
                  {/* <CommonButton
                    variant="outlined"
                    color="#344054"
                    border="#D0D5DD"
                    fontWeight="600"
                    value="Share"
                    padding="10px 20px"
                    disabled={isLoading}
                  /> */}

                  <CommonButton
                    variant="outlined"
                    color="#344054"
                    border="#D0D5DD"
                    fontWeight="600"
                    value="Save"
                    type="submit"
                    padding="10px 20px"
                    disabled={
                      isLoading || buttonLoading.disabled || values.is_updated
                    }
                    loading={buttonLoading.submitLoading}
                    onClick={async () => {
                      let data = await validateForm();
                      setTimeout(() => {
                        handleScrollToError(data);
                      }, 0);
                    }}
                  />
                  <CommonButton
                    value="Verify"
                    padding="10px 20px"
                    fontWeight="600"
                    onClick={() => handleVerified(values)}
                    disabled={
                      isLoading || buttonLoading.disabled || values.is_updated
                    }
                    loading={buttonLoading.verifiedLoading}
                  />
                </CommonGrid2>
              </Grid2>

              <Grid2 container spacing={5}>
                <Grid2 size={12} marginTop={"3rem"}>
                  <CommonAccordion
                    title={"Editable Information"}
                    open={expandedPanel.includes("Editable Information")}
                    onChange={handleChangeAccor("Editable Information")}
                    children={
                      <SubmissionMixedComponent
                        editData={editableInformation}
                        marginTop={"0px"}
                        loading={isLoading}
                      />
                    }
                  />
                </Grid2>
                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Justification"}
                    open={expandedPanel.includes("Justification")}
                    onChange={handleChangeAccor("Justification")}
                    children={
                      <Justification
                        loading={isLoading}
                        handleChatBotChange={handleChatBotChange}
                        chatBotData={chatBotData}
                        handleIconClick={handleIconClick}
                      />
                    }
                  />
                </Grid2>

                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Skill Summary"}
                    open={expandedPanel.includes("Skill Summary")}
                    onChange={handleChangeAccor("Skill Summary")}
                    children={
                      <CommonTable
                        data={tableData.skills_summary}
                        columns={skillSummaryHeader}
                        onSortChange={(col) => console.log("Sort by", col)}
                        handleTableBodyData={(row, index) =>
                          handleSkillSummaryTableBodyData(
                            row,
                            index,
                            setFieldValue,
                            "skills_summary"
                          )
                        }
                        marginTop={"0rem"}
                        withPagination={false}
                        loading={isLoading}
                        loadingRowLength={2}
                      />
                    }
                  />
                </Grid2>

                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Supporting Evidence"}
                    open={expandedPanel.includes("Supporting Evidence")}
                    onChange={handleChangeAccor("Supporting Evidence")}
                    children={
                      <CommonTable
                        data={tableData.supporting_evidence}
                        columns={supportingEvidenceHeader}
                        onSortChange={(col) => console.log("Sort by", col)}
                        handleTableBodyData={(row, index) =>
                          handleSummaryEvidenceTableBodyData(
                            row,
                            index,
                            setFieldValue,
                            "supporting_evidence"
                          )
                        }
                        marginTop={"0rem"}
                        withPagination={false}
                        loading={isLoading}
                        loadingRowLength={2}
                      />
                    }
                  />
                </Grid2>

                {/* <Grid2 size={12}>
                  <CommonAccordion
                    title={"Risk Analysis"}
                    buttonTitle="Add"
                    open={expandedPanel.includes("Risk Analysis")}
                    onChange={handleChangeAccor("Risk Analysis")}
                    accordionButton
                    onButtonClick={() =>
                      handleAddRiskAnalysis(
                        setFieldValue,
                        "risks_and_remediation",
                        values
                      )
                    }
                    children={
                      <CommonTable
                        data={tableData.risks_and_remediation}
                        columns={riskAnalysis}
                        onSortChange={(col) => console.log("Sort by", col)}
                        handleTableBodyData={(row, index) =>
                          handleRiskAnalysisTableBodyData(
                            row,
                            index,
                            setFieldValue,
                            "risks_and_remediation",
                            errors["risks_and_remediation"]
                          )
                        }
                        marginTop={"0rem"}
                        withPagination={false}
                        loading={isLoading}
                        loadingRowLength={2}
                      />
                    }
                  />
                </Grid2> */}

                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Job Summary"}
                    open={expandedPanel.includes("Job Summary")}
                    onChange={handleChangeAccor("Job Summary")}
                    children={
                      <SubmissionMixedComponent
                        editData={jobSummary}
                        marginTop={"0px"}
                        loading={isLoading}
                      />
                    }
                  />
                </Grid2>
                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Candidate Information"}
                    open={expandedPanel.includes("Candidate Information")}
                    onChange={handleChangeAccor("Candidate Information")}
                    children={
                      <>
                        <SubmissionMixedComponent
                          editData={candidateInformation}
                          marginTop={"0px"}
                          loading={isLoading}
                        />
                        {values.pre_screen_question_answers?.length !== 0 && (
                          <>
                            <Typography
                              variant="h4"
                              margin={"1.5rem 0px"}
                              fontWeight={600}
                            >
                              {"Pre-Screening Questions and Answers"}
                            </Typography>
                            <PreScreenQuestion loading={isLoading} />
                          </>
                        )}
                      </>
                    }
                  />
                </Grid2>
                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Prior working with Client"}
                    open={expandedPanel.includes("Prior working with Client")}
                    onChange={handleChangeAccor("Prior working with Client")}
                    children={
                      <SubmissionMixedComponent
                        editData={previous_experience_with_client}
                        marginTop={"0px"}
                        loading={isLoading}
                      />
                    }
                  />
                </Grid2>
                <Grid2 size={12}>
                  <CommonAccordion
                    title={"Engagement"}
                    open={expandedPanel.includes("Engagement")}
                    onChange={handleChangeAccor("Engagement")}
                    children={
                      <SubmissionMixedComponent
                        editData={previous_tax_term}
                        marginTop={"0px"}
                        loading={isLoading}
                      />
                    }
                  />
                </Grid2>
              </Grid2>
            </Form>
          );
        }}
      </Formik>
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      <SkillDeleteDialog
        deleteDialog={riskAnalysisDialog.open}
        handleDeleteDialogClose={handleRiskAnalysisDialogDialogClose}
        handleDeleteSkill={handleDeleteRiskAnalysis}
        buttonLoading={riskAnalysisDialog.loading}
        title="Delete Risk Analysis"
        content={riskAnalysisDialog.data?.row?.risk}
      />
    </CustomDiv>
  );
}
